var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.9422 77.3931L37.8916 67.4338M5.72166 49.6715C2.56159 77.1051 22.238 101.905 49.6715 105.065C77.1051 108.225 101.905 88.5485 105.065 61.1149C108.225 33.6813 88.5485 8.88174 61.1149 5.72166C33.6813 2.56159 8.88174 22.238 5.72166 49.6715Z",
    stroke: "#573B76",
    strokeOpacity: 0.05,
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7246 38.4891C39.0659 38.4132 38.4644 38.0788 38.0522 37.5594C37.6401 37.04 37.4512 36.3781 37.5271 35.7194C37.603 35.0607 37.9374 34.4592 38.4568 34.0471C38.9762 33.6349 39.6381 33.446 40.2968 33.5219C40.9555 33.5978 41.557 33.9322 41.9691 34.4516C42.3813 34.971 42.5701 35.6329 42.4943 36.2916C42.4184 36.9503 42.084 37.5518 41.5646 37.9639C41.0451 38.3761 40.3833 38.565 39.7246 38.4891ZM74.4947 42.4942C73.836 42.4184 73.2344 42.0839 72.8223 41.5645C72.4102 41.0451 72.2213 40.3833 72.2972 39.7246C72.3731 39.0659 72.7075 38.4643 73.2269 38.0522C73.7463 37.6401 74.4082 37.4512 75.0669 37.5271C75.7255 37.603 76.3271 37.9374 76.7392 38.4568C77.1513 38.9762 77.3402 39.6381 77.2644 40.2967C77.1885 40.9554 76.8541 41.557 76.3346 41.9691C75.8152 42.3812 75.1534 42.5701 74.4947 42.4942Z",
    fill: "#573B76",
    fillOpacity: 0.05,
    stroke: "#573B76",
    strokeOpacity: 0.05,
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.6e17029f528028baae66dfa623b4a06e.svg";
export { ForwardRef as ReactComponent };